function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import toolCom from '@/components/PageDiy/mobileConfigRight/index.js';
import rightBtn from '@/components/PageDiy/rightBtn/index.vue';
import { mapGetters } from 'vuex';
export default {
  name: 'c_home_merchant',
  componentsName: 'home_merchant',
  computed: _objectSpread({}, mapGetters(['mediaDomain'])),
  components: _objectSpread(_objectSpread({}, toolCom), {}, {
    rightBtn: rightBtn
  }),
  props: {
    activeIndex: {
      type: null
    },
    num: {
      type: null
    },
    index: {
      type: null
    }
  },
  data: function data() {
    return {
      configObj: {},
      rCom: [{
        components: toolCom.c_checked_tab,
        configNme: 'setUp'
      }]
    };
  },
  watch: {
    num: function num(nVal) {
      var value = JSON.parse(JSON.stringify(this.$store.state.mobildConfig.defaultArray[nVal]));
      this.configObj = value;
    },
    configObj: {
      handler: function handler(nVal, oVal) {
        this.$store.commit('mobildConfig/UPDATEARR', {
          num: this.num,
          val: nVal
        });
      },
      deep: true
    },
    'configObj.setUp.tabVal': {
      handler: function handler(nVal, oVal) {
        var arr = [this.rCom[0]];
        if (nVal == 0) {
          var tempArr = [{
            components: toolCom.c_title,
            configNme: 'tabConfig'
          }, {
            components: toolCom.c_txt_tab,
            configNme: 'tabConfig'
          }, {
            components: toolCom.c_title,
            configNme: 'logoConfig'
          }, {
            components: toolCom.c_upload_img,
            configNme: 'logoConfig'
          }, {
            components: toolCom.c_title,
            configNme: 'titleConfig'
          }, {
            components: toolCom.c_input_item,
            configNme: 'titleConfig'
          }, {
            components: toolCom.c_input_item,
            configNme: 'linkConfig'
          }, {
            components: toolCom.c_title,
            configNme: 'typeConfig'
          }, {
            components: toolCom.c_checkbox_group,
            configNme: 'typeConfig'
          }, {
            components: toolCom.c_title,
            configNme: 'listConfig'
          }, {
            components: toolCom.c_tab_radio,
            configNme: 'listConfig'
          }, {
            components: toolCom.c_input_number,
            configNme: 'numConfig'
          }, {
            components: toolCom.c_merchantName,
            configNme: 'activeValueMer'
          }];
          this.rCom = arr.concat(tempArr);
        } else {
          var _tempArr = [{
            components: toolCom.c_title,
            configNme: 'bgColor'
          }, {
            components: toolCom.c_bg_color,
            configNme: 'bgColor'
          }, {
            components: toolCom.c_bg_color,
            configNme: 'titleColor'
          }, {
            components: toolCom.c_bg_color,
            configNme: 'nameColor'
          }, {
            components: toolCom.c_bg_color,
            configNme: 'labelColor'
          }, {
            components: toolCom.c_bg_color,
            configNme: 'labelFontColor'
          }, {
            components: toolCom.c_bg_color,
            configNme: 'moreColor'
          }, {
            components: toolCom.c_bg_color,
            configNme: 'merColor'
          }, {
            components: toolCom.c_title,
            configNme: 'upConfig'
          }, {
            components: toolCom.c_slider,
            configNme: 'upConfig'
          }, {
            components: toolCom.c_slider,
            configNme: 'downConfig'
          }, {
            components: toolCom.c_slider,
            configNme: 'mbConfig'
          }, {
            components: toolCom.c_title,
            configNme: 'bgStyle'
          }, {
            components: toolCom.c_slider,
            configNme: 'bgStyle'
          }, {
            components: toolCom.c_slider,
            configNme: 'contentStyle'
          }];
          this.rCom = arr.concat(_tempArr);
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      var value = JSON.parse(JSON.stringify(_this.$store.state.mobildConfig.defaultArray[_this.num]));
      _this.configObj = value;
      // this.configObj.logoConfig.url = this.mediaDomain + '/crmebimage/presets/haodian.png';
    });
  },
  created: function created() {},
  methods: {
    getConfig: function getConfig(data) {
      if (data.name === 'tab_radio' && data.values === 0) {
        this.configObj.numConfig.isShow = 1;
        this.configObj.activeValueMer.isShow = 0;
      } else if (data.name === 'tab_radio' && data.values === 1) {
        this.configObj.numConfig.isShow = 0;
        this.configObj.activeValueMer.isShow = 1;
      }
    }
  }
};